<template>
  <div>
    <div class="video-mask">
      <div><iframe src="https://giphy.com/embed/GyNeHf5IrpQNG" style="left: -20px"  width="120%" height="110%" frameBorder="0" class="giphy-embed" allowFullScreen></iframe></div>
    </div>
    <h1>Deze actie is momenteel niet te gebruiken.</h1>
  </div>
</template>

<script>
export default {
  name: 'Disabled',
};
</script>

<style lang="scss">
</style>
